// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop__35_WX"};